module.exports = __webpack_public_path__ + "static/media/bg_talentos.f39cdc5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_talentos.png
// module id = 1271
// module chunks = 0